import React from 'react';

/* eslint-disable */
const PlusCircle = (props) => (
  <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<circle cx="14.1509" cy="13.4888" r="13.3789" fill="#FCD406"/>
<path d="M15.2671 7.16712C15.2671 6.54978 14.7658 6.04849 14.1485 6.04849C13.5311 6.04849 13.0298 6.54978 13.0298 7.16712L13.0323 12.3701L7.82934 12.3726C7.212 12.3726 6.71072 12.8738 6.71072 13.4912C6.71072 14.1085 7.212 14.6098 7.82934 14.6098L13.0323 14.6073L13.0348 19.8103C13.0348 20.4276 13.5361 20.9289 14.1534 20.9289C14.7707 20.9289 15.272 20.4276 15.272 19.8103L15.2696 14.6073L20.4725 14.6049C21.0899 14.6049 21.5911 14.1036 21.5911 13.4862C21.5911 12.8689 21.0899 12.3676 20.4725 12.3676L15.2696 12.3701L15.2671 7.16712Z" fill="white"/>
</svg>

);
/* eslint-enable */

export default PlusCircle;
